import { useController } from '@framework/form/hooks/useController.ts';
import {
  SelectInput,
  type SelectOption,
} from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { SelectDetailedOption } from '@framework/ui/components/select/SelectDetailedOption.tsx';
import { RuleType } from '../../IRule.ts';
import { WhiteSpaceMode } from './WhiteSpaceMode.ts';

const fieldName = `rules.${RuleType.WhiteSpace}`;
const valueField = `${fieldName}.value`;

const options: SelectOption[] = [
  {
    label: 'Sostituisci',
    value: WhiteSpaceMode.Replace,
  },
  {
    label: 'Comprimi',
    value: WhiteSpaceMode.Collapse,
  },
];

const descriptions: Record<WhiteSpaceMode, string> = {
  [WhiteSpaceMode.Replace]:
    'Tabulazioni, ritorni a capo e avanzamenti riga vengono sostituiti con spazi.',
  [WhiteSpaceMode.Collapse]:
    'Gli spazi iniziali e finali vengono rimossi e gli spazi multipli vengono ridotti a uno.',
};

function renderOption(option: SelectOption) {
  const mode = option.value as WhiteSpaceMode;
  return (
    <SelectDetailedOption
      label={option.label}
      description={descriptions[mode]}
    />
  );
}

export function WhiteSpaceRuleComponent() {
  const { field } = useController(valueField);

  return (
    <FormItem name={valueField} label="Gestione spazi bianchi">
      <SelectInput
        name={valueField}
        allowClear
        onClear={() => {
          field.onChange(null);
        }}
        options={options}
        renderOption={renderOption}
        style={{
          height: 'auto',
          minHeight: '40px',
        }}
        popupMatchSelectWidth
      />
    </FormItem>
  );
}
